import "lazysizes";
import Headroom from "headroom.js";
import { Autoplay, EffectFade, Lazy, Navigation, Swiper } from "swiper";
import { debounce, normalizeVH } from "./bundle/rcobiella-helpers.js";

// import Scrollbar from "smooth-scrollbar";
import Swup from "swup";
import SwupBodyClassPlugin from "@swup/body-class-plugin";
import SwupDebugPlugin from "@swup/debug-plugin";
import SwupJsPlugin from "@swup/js-plugin";
import SwupPreloadPlugin from "@swup/preload-plugin";
import { gsap, Power3 } from "gsap";

Swiper.use([Navigation, EffectFade, Lazy, Autoplay]);

normalizeVH();

window.onresize = () => {
	normalizeVH();
};

// grab an element
var _h = document.querySelector("header");
// construct an instance of Headroom, passing the element
var headroom = new Headroom(_h);
// initialise
headroom.init();

/* -------------------------------------------------------------------------- */
/*                              LazySizes config                              */
/* -------------------------------------------------------------------------- */

window.lazySizesConfig = {
	loadMode: 3,
	expand: 1000,
};

var mainScroll;

jQuery(function ($) {
	/* -------------------------------------------------------------------------- */
	/*                              isMobile & TOUCH                              */
	/* -------------------------------------------------------------------------- */

	var TOUCH = "ontouchstart" in window;

	var isMobile = window.innerWidth <= 1024;

	const checkMobile = () => {
		isMobile = window.innerWidth <= 1024;
	};
	window.addEventListener("resize", debounce(checkMobile, 20));

	/* ---------------------------------------------------------------- */
	/*                             Pointer                              */
	/* ---------------------------------------------------------------- */
	var isMouseInit = false;
	function init_pointer2() {
		let $cursorEls = $("[data-cursor]");
		isMouseInit = true;

		// Gets the mouse position
		const getMousePos = (e) => {
			return {
				x: e.clientX,
				y: e.clientY,
			};
		};
		// Linear interpolation
		const lerp = (a, b, n) => (1 - n) * a + n * b;

		//Grab mouse position and set it to mouse state
		let mouse = { x: 0, y: 0 };
		window.addEventListener("mousemove", (ev) => (mouse = getMousePos(ev)));

		class Cursor {
			constructor(el) {
				this.Cursor = el;
				// this.Follower = document.querySelector(".cursor-follow");
				this.Cursor.style.opacity = 0;

				this.cursorCnfigs = {
					x: { previous: 0, current: 0, amt: 0.2 },
					y: { previous: 0, current: 0, amt: 0.2 },
				};

				this.onMouseMoveEv = () => {
					this.cursorCnfigs.x.previous = this.cursorCnfigs.x.current =
						mouse.x;
					this.cursorCnfigs.y.previous = this.cursorCnfigs.y.current =
						mouse.y;

					// Set cursor opacity to 1 when hovered on the screen
					gsap.to(this.Cursor, {
						duration: 1,
						ease: "Power3.easeInOut",
						opacity: 1,
					});
					// gsap.to(this.Follower, {
					// 	duration: 1.2,
					// 	ease: "Power3.easeInOut",
					// 	opacity: 1,
					// });

					//    requestAnimationFrame
					requestAnimationFrame(() => this.render());

					//    Cleanup function
					window.removeEventListener("mousemove", this.onMouseMoveEv);
				};
				//    Assign the mouse function
				window.addEventListener("mousemove", this.onMouseMoveEv);
				const cursorDis = this;

				$("body").on(
					"mouseenter mouseleave mousedown mouseup",
					"[data-cursor]",
					function (e) {
						const $dis = $(this);
						let cursorType = this.dataset.cursor || false;
						if (!cursorType) return false;

						let caption = this.dataset.caption || false;
						if (e.type == "mouseenter") {
							if (caption) {
								document.documentElement.style.setProperty(
									"--cursorCaption",
									`"${caption}"`
								);
							}
							cursorDis.Cursor.classList.add("is-hover");
							cursorDis.Cursor.classList.add(cursorType);
							// cursorDis.Follower.classList.add("is-hover");
						} else if (e.type == "mouseleave") {
							// cursorDis.Cursor.classList.remove("is-hover");
							// cursorDis.Follower.classList.remove("is-hover");
							cursorDis.Cursor.classList = "";
							if (caption) {
								document.documentElement.style.setProperty(
									"--cursorCaption",
									""
								);
							}
						} else if (e.type == "mousedown") {
							cursorDis.Cursor.classList.add("is-mousedown");
						} else if (e.type == "mouseup") {
							cursorDis.Cursor.classList.remove("is-mousedown");
						}
					}
				);
				document.addEventListener("swup:contentReplaced", (event) => {
					// remove cursor
					cursorDis.Cursor.classList = "";
					document.documentElement.style.setProperty(
						"--cursorCaption",
						""
					);
				});
			}

			render() {
				this.cursorCnfigs.x.current = mouse.x;
				this.cursorCnfigs.y.current = mouse.y;
				for (const key in this.cursorCnfigs) {
					this.cursorCnfigs[key].previous = lerp(
						this.cursorCnfigs[key].previous,
						this.cursorCnfigs[key].current,
						this.cursorCnfigs[key].amt
					);
				}
				//    setting the cursor x and y to our cursor html element
				this.Cursor.style.transform = `translate3d(${this.cursorCnfigs.x.previous}px,${this.cursorCnfigs.y.previous}px, 0)`;
				// this.Follower.style.transform = `translate3d(${this.cursorCnfigs.x.previous}px,${this.cursorCnfigs.y.previous}px, 0)`;

				requestAnimationFrame(() => this.render());
			}
		}
		const cursor = new Cursor(document.querySelector("#cursor"));

		window.addEventListener("load", function () {
			// let c2 = document.querySelector(".cursor-follow"),
			let c1 = document.querySelector("#cursor");

			// gsap.to(c2, {
			// 	autoAlpha: 1,
			// 	duration: 1.5,
			// 	delay: 1.5,
			// });
			gsap.to(c1, {
				autoAlpha: 1,
				duration: 1.5,
				delay: 1.5,
			});
		});
	}
	if (!TOUCH && !isMouseInit) {
		init_pointer2();
	}

	/* ---------------------------------------------------------------- */
	/*                           Update vars                            */
	/* ---------------------------------------------------------------- */

	const root = document.documentElement,
		$Header = $("header.header");

	function addListenerMulti(el, events, fn) {
		events.split(" ").forEach((e) => el.addEventListener(e, fn, false));
	}

	window.onload = function () {
		setVars();
	};
	root.addEventListener("resize", setVars);

	var setVars = (e) => {
		root.style.setProperty("--header-h", `${$Header[0].offsetHeight}px`);
	};
	setVars();

	/* ---------------------------------------------------------------- */
	/*                            Scroll to                             */
	/* ---------------------------------------------------------------- */

	$("body").on("click", "[data-scrollto]", scrollToElement);

	function scrollToElement(e) {
		console.log(this, e);
		let $dis = $(this),
			scrollToData = $dis.data("scrollto"),
			$scrollToEl = $(scrollToData);
		if ($dis.length && scrollToData && $scrollToEl.length) {
			$scrollToEl.get(0).scrollIntoView({
				behavior: "smooth",
			});
		}
	}

	/* ---------------------------------------------------------------- */
	/*                               SWUP                               */
	/* ---------------------------------------------------------------- */

	const swupJsOptions = [
		{
			from: "(.*)",
			to: "(.*)",

			in: function (next) {
				console.log("in");
				next();
			},
			out: (next) => {
				console.log("out");
				$("#swup").css("opacity", "0");
				setTimeout(function () {
					next();
				}, 500);
			},
		},
	];

	const swupOptions = {
		plugins: [
			new SwupDebugPlugin(),
			new SwupPreloadPlugin(),
			new SwupBodyClassPlugin(),
			new SwupJsPlugin(swupJsOptions),
		],
		containers: ["#swup"],
		animateHistoryBrowsing: true,
	};
	const swup = new Swup(swupOptions);

	$(document).on("swup:pageView", function (event) {
		window.scrollTo(0, 0);

		initSliders();
		initScroll();
		setTimeout(function () {
			window.scrollTo(0, 0);
		}, 1);

		setTimeout(function () {
			$("#swup").css("opacity", "1");
		}, 300);
	});

	$(window).on("load", function () {
		initScroll();
		$("#swup").css("opacity", "1");
	});

	// Scrollbar
	function initScroll() {
		if ($("body").hasClass("single-proyectos")) {
			$("html").css("scroll-behavior", "auto");
		} else {
			$("html").css("scroll-behavior", "smooth");
		}
		// if (Scrollbar.has(document.body)) {
		// 	mainScroll.scrollTop = 0;
		// 	Scrollbar.destroy(document.body);
		// }
		// if ($("body").hasClass("single-proyectos")) {
		// 	return false;
		// }

		// mainScroll = Scrollbar.init(document.body, {
		// 	thumbMinSize: 0,
		// 	damping: 0.1,
		// });
	}

	/* ---------------------------------------------------------------- */
	/*                    Info trigger en proyectod                     */
	/* ---------------------------------------------------------------- */

	$("body").on("click", ".trigger-info", toggleInfo);

	function toggleInfo() {
		let $bottom = $(".proyecto-bottom");
		$("body").toggleClass("info-is-opened");
	}

	$("body").on("click", function (e) {
		if ($(this).hasClass("info-is-opened")) {
			let $target = $(e.target);
			if (
				$target.hasClass("slider-container") ||
				$target.parents(".slider-container").length
			) {
				$("body").removeClass("info-is-opened");
			}
		}
	});

	$(document).keyup(function (e) {
		// if (e.which === 13) $(".save").click(); // enter
		if (e.which === 27 && $("body").hasClass("info-is-opened")) {
			$("body").removeClass("info-is-opened");
		}
		/* OPTIONAL: Only if you want other elements to ignore event */
		// e.preventDefault();
		// e.stopPropagation();
	});

	/* ---------------------------------------------------------------- */
	/*                         SLIDER - Swiper                          */
	/* ---------------------------------------------------------------- */

	var sliderOptionsClasses = {
		containerModifierClass: "slider-container-",
		slideClass: "slider-slide",
		slideActiveClass: "slider-slide-active",
		slideDuplicateActiveClass: "slider-slide-duplicate-active",
		slideVisibleClass: "slider-slide-visible",
		slideDuplicateClass: "slider-slide-duplicate",
		slideNextClass: "slider-slide-next",
		slideDuplicateNextClass: "slider-slide-duplicate-next",
		slidePrevClass: "slider-slide-prev",
		slideDuplicatePrevClass: "slider-slide-duplicate-prev",
		slideBlankClass: "slider-slide-invisible-blank",
		wrapperClass: "slider-wrapper",
	};

	var sliderOptionsNormal = {
		...sliderOptionsClasses,
		direction: "horizontal",
		loop: true,
		effect: "fade",
		slidesPerView: 1,
		fadeEffect: {
			crossFade: true,
		},
		allowSlideNext: true,
		allowSlidePrev: true,
		preventInteractionOnTransition: true,
		navigation: {
			nextEl: ".slider-button-next",
			prevEl: ".slider-button-prev",
		},
		// autoplay: {
		// 	delay: 5000,
		// 	disableOnInteraction: true,
		// },
		speed: 400,
		lazy: {
			loadPrevNext: true,
			loadPrevNextAmount: 1,
		},
	};

	var sliderOptionsHome = {
		on: {
			init: updSwiperNumericPagination,
			slideChange: updSwiperNumericPagination,
		},
		...sliderOptionsNormal,
	};

	/**
	 * Update of secondary numeric pagination
	 * https://codepen.io/OXAYAZA/pen/ybpYjL
	 * @this {object}  - swiper instance
	 */
	function updSwiperNumericPagination() {
		let $counter = $(this.$el).find(".slider-counter");
		console.log($(this.$el));
		console.log($counter);
		if ($counter.length) {
			let curr = this.realIndex + 1,
				tot = this.slides.length - 2;

			curr = curr < 10 ? "0" + curr : curr;
			tot = tot < 10 ? "0" + tot : tot;
			$counter[0].innerHTML = `<span class="count">${curr}</span>
				<span class="sep">/</span>
				<span class="total">${tot}</span>`;
		}
	}

	function initSliders() {
		let $allSliders = $(".slider-container");
		if ($allSliders.length) {
			$allSliders.each(function (index) {
				let $dis = $(this),
					dis = this,
					$sliderNext = $dis.find(".slider-button-next"),
					$sliderPrev = $dis.find(".slider-button-prev"),
					$sliderCount = $dis.find(".slider-count"),
					sliderClass = `.slider-id-${index}`,
					isHome = $dis.hasClass("slider-home");

				$dis.addClass(`slider-id-${index}`);

				var mySwiper = new Swiper(
					sliderClass,
					isHome ? sliderOptionsHome : sliderOptionsHome
				);
				window.mySwiper = mySwiper;
			});
		}
	}
	initSliders();

	/* -------------------------------------------------------------------------- */
	/*                                Loader + AOS                                */
	/* -------------------------------------------------------------------------- */

	let ignore_unload = false;

	// Prevent if link has mailto
	// $("a[href^=mailto], a[href^=tel]").on("click", function () {
	// 	ignore_unload = true;
	// });

	// $(window).on("beforeunload", function (e) {
	// 	if (!ignore_unload) {
	// 		$("#loader").removeClass("is-loaded");
	// 	}
	// 	ignore_unload = false;
	// });

	$(window).on("load", function () {
		setTimeout(function () {
			let hash = location.hash;
			if (hash) {
				hash = hash.replace("#", "");
				let scrollToNode = document.getElementById(hash);
				if (scrollToNode) {
					window.scrollTo({
						top: scrollToNode.offsetTop,
						behavior: "auto",
					});
				}
			}

			// Remove preload-transitions class from body to re-enable transitions
			$("body").removeClass("preload-transitions");
			$("#loader").addClass("is-loaded");
		}, 0);
	});
});
